<template>
    <div>
         <div class="footer">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>关于我们</p>
              <span>董事长寄语</span>
              <span>集团简介</span>
              <span>公司荣誉</span>
              <span>企业理念</span>
              <span>团队风采</span>
            </li>
            <li>
              <p>前瞻战略</p>
              <span>大健康食品产业链</span>
              <span>循环经济乡村振兴</span>
            </li>
            <li>
              <p>发展领域</p>
              <span>智慧团膳连锁产业</span>
              <span>智能中央厨房产业</span>
              <span>食品供应链产业</span>
              <span>现代农业产业</span>
              <span>休闲康养产业</span>
            </li>
            <li>
              <p>业务优势</p>
              <span>智能生产设备</span>
              <span>智慧管理系统</span>
              <span>五行膳食研创</span>
              <span>聚利和商学院</span>
              <span>增值服务</span>
            </li>
              <li>
              <p>联系我们</p>
              <span>
                <img src="../assets/img/u111.png" alt="" style="padding:0px;width:13px;height:13px;vertical-align:middle;margin-right:8px;">
                <span>集团官网：www.julihe.com</span>
              </span>
               <span>
                <img src="../assets/img/u109.png" alt="" style="padding:0px;width:13px;height:13px;vertical-align:middle;margin-right:8px;">
                <span>服务热线：400-626-5855</span>
              </span>
               <span>
                <img src="../assets/img/u110.png" alt="" style="padding:0px;width:13px;height:13px;vertical-align:middle;margin-right:8px;">
                <span>总机：010-68646658</span>
              </span>
               <span>
                <img src="../assets/img/u114.png" alt="" style="padding:0px;width:13px;height:13px;vertical-align:middle;margin-right:8px;">
                <span>传真：010-68646605</span>
              </span>
               <span>
                <img src="../assets/img/u112.png" alt="" style="padding:0px;width:13px;height:13px;vertical-align:middle;margin-right:8px;">
                <span>邮箱：julihe@vip.126.com</span>
              </span>
               <span>
                <img src="../assets/img/u113.png" alt="" style="padding:0px;width:13px;height:13px;vertical-align:middle;margin-right:8px;">
                <span>地址：北京市大兴区鼎业路7号院1号楼</span>
              </span>
            </li>
          </ul>
          <div>
            <div style="color:#fff;font-size:14px;text-align:center;margin-bottom:20px;">微信公众号</div>
          <img src="../assets/img/wechat123.png" alt style="width:120px;height:120px;padding:0px;" />
          </div>
          <div>
           <div style="color:#fff;font-size:14px;text-align:center;margin-bottom:20px;">企业抖音号</div>
          <img src="../assets/img/_u89.png" alt style="width:120px;height:120px;padding:0px;" />
          </div>
        </div>
        <div class="copyright">
          <span @click="tohref"> <router-link to="" style="text-decoration: none;color:#fff;">@聚利和 版权所有2009-2021  京ICP备12009157号-1 </router-link></span>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: "botsolid",
  methods:{
    tohref(){
      window.open("https://beian.miit.gov.cn/#/Integrated/index")
      // location.href="https://beian.miit.gov.cn/#/Integrated/index"
    }
  }
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: auto;
  // position: fixed;
  bottom: 0px;
  overflow: hidden;
  background-color: #0277C7;
  border-top: 10px solid #014F85;
  &-content {
    width: 85%;
    margin: 0 auto;
    padding-top: 25px;
    margin-bottom: 40px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      width:calc(100% - 350px);
      display: flex;
      justify-content: space-between;
      li {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        p {
          font-size: 17px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
          font-size: 14px;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    background: #0277C7;
    background-color: #0277C7;
    align-content: center;
    text-align: center;
    span {
      color: #fff;
      padding-top: 10px;
      padding-bottom: 30px;
      display: block;
      position: relative;
      font-size:13px;
    }
  }
}
</style>